import {HttpClient, HttpHeaders, HttpResponse} from "@angular/common/http";
import {Observable} from "rxjs";
import {Order} from "../../store/state/order.state";
import {environment} from "../../../environments/environment";
import {AdditionalQuestionsRequest} from "./request-bodies";

export class SalesEndpoints {

	constructor(private http: HttpClient) {
	}

	takeOver(correlationId: string): Observable<Order> {
		const url: string = `${environment.apiUrl}/sales-lead/${correlationId}/take-over`;
		return this.http.post<Order>(url, null);
	}

	cancelTakeOver(correlationId: string): Observable<Order> {
		const url: string = `${environment.apiUrl}/sales-lead/${correlationId}/cancel-take-over`;
		return this.http.post<Order>(url, null);
	}

	updateSalesLead(correlationId: string, order: Order): Observable<Order> {
		const url: string = `${environment.apiUrl}/sales-lead/${correlationId}/update`;
		return this.http.post<Order>(url, order, {headers: new HttpHeaders({"Content-Type": "application/json;charset=UTF-8"})});
	}

	getSalesLead(correlationId: string): Observable<Order> {
		const url: string = `${environment.apiUrl}/sales-lead/${correlationId}`;
		return this.http.get<Order>(url);
	}

	saveAdditionalQuestions(correlationId: string, requests: AdditionalQuestionsRequest[]): Observable<HttpResponse<any>> {
		const url: string = `${environment.apiUrl}/sales-lead/${correlationId}/additional-questions`;
		return this.http.post<any>(url, requests, {
			headers: new HttpHeaders({"Content-Type": "application/json;charset=UTF-8"}),
			observe: "response"
		});
	}

	isLoggedUserAssignedToSalesLead(correlationId: string): Observable<boolean> {
		const url: string = `${environment.apiUrl}/sales-lead/${correlationId}/check-permission`;
		return this.http.get<boolean>(url);
	}

	sendUpdateToClient(correlationId: string, reviewerChangeComment: string): Observable<HttpResponse<any>> {
		const url: string = `${environment.apiUrl}/sales-lead/${correlationId}/send-lead-update-to-client`;
		return this.http.post<any>(url, reviewerChangeComment, {
			headers: new HttpHeaders({"Content-Type": "application/json;charset=UTF-8"}),
			observe: "response"
		});
	}

	getSalesPeople(): Observable<Map<string, string[]>> {
		const url: string = `${environment.apiUrl}/sales-lead/salespeople`;
		return this.http.get<Map<string, string[]>>(url, {responseType: "json", headers: {'Content-Type': 'application/json;charset=UTF-8'}});
	}

	archiveSalesLead(correlationId: string): Observable<HttpResponse<any>> {
		const url: string = `${environment.apiUrl}/sales-lead/${correlationId}/archive-sales-lead`;
		return this.http.post<any>(url, null, {headers: new HttpHeaders({"Content-Type": "application/json;charset=UTF-8"}), observe: "response"});
	}
}
